
import gsap from 'gsap';
import scrollTrigger from 'gsap/dist/ScrollTrigger';

gsap.registerPlugin(scrollTrigger)

window.addEventListener('frame-ready', init)

function init() {

    let items = Array.from(document.querySelectorAll('.scroll-in-up'))

    if (items.length > 0) {

        gsap.timeline({
            scrollTrigger: {
                trigger: items,
                start: 'bottom bottom',
            }
        }).to(items, {
            opacity: 1,
            translateY: 0,
            stagger: (index) => {
                return index * 0.1 - (index * 0.05)
            }
        })
    }
}
